/**
 * @author Mikhail.Kokoulin
 * @version 1.0.0
 */
import React, { lazy, Suspense } from 'react';

import { Loader } from '../modules/loader/components/Loader';

/**
 * The utils split react component load
 * @param importFunc {Promise}
 * @param fallback {ReactElement} element to render during loading
 */
const loadable = (importFunc: () => Promise<{ default: React.ComponentType<any> }>,
                  fallback = <Loader showLoader={true}/>) => {
    const LazyComponent = lazy(importFunc);

    return (props: any) =>
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
};

export default loadable;
